import { PanelSection, Skeleton } from '@dev-spendesk/grapes';

import { useCompany } from 'modules/app/hooks/useCompany';
import { BillingAddress } from 'modules/requests/address/BillingAddress';
import { QuerySuspense } from 'src/core/common/components/QuerySuspense';
import { useCardAddressQuery } from 'src/core/common/hooks/useCardAddressQuery';
import { useTranslation } from 'src/core/common/hooks/useTranslation';

export const CardAddress = ({
  cardId,
  showSubtitle,
}: {
  cardId: string;
  showSubtitle?: boolean;
}) => {
  const cardAddressQuery = useCardAddressQuery(cardId);
  const company = useCompany();
  const { t } = useTranslation('global');

  return (
    <QuerySuspense
      queryState={cardAddressQuery}
      loading={
        <PanelSection title={t('card.billingAddress')}>
          <Skeleton
            width="100%"
            height="150px"
            className="mx-auto block rounded-12"
          />
        </PanelSection>
      }
      // For now, explicitly not showing any error message (BANKGATE-2385).
      fallback={() => null}
    >
      {({ address, address2, zipCode, city, country: countryCode }) => (
        <BillingAddress
          companyName={company.name}
          address={address}
          address2={address2}
          zipCode={zipCode}
          city={city}
          countryKey={countryCode}
          companyVat={company.vat}
          showSubtitle={showSubtitle}
        />
      )}
    </QuerySuspense>
  );
};
